import { render, staticRenderFns } from "./PacksVerification.vue?vue&type=template&id=be35211a&scoped=true&"
import script from "./PacksVerification.vue?vue&type=script&lang=js&"
export * from "./PacksVerification.vue?vue&type=script&lang=js&"
import style0 from "./PacksVerification.vue?vue&type=style&index=0&id=be35211a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be35211a",
  null
  
)

export default component.exports